import Model from "./model";

interface CornerRadiusParams {
    topLeft: number;
    topRight: number;
    bottomRight: number;
    bottomLeft: number;
}

export default class CornerRadius extends Model {
    topLeft: number;
    topRight: number;
    bottomRight: number;
    bottomLeft: number;

    constructor(params: CornerRadiusParams) {
        super();
        this.topLeft = params.topLeft;
        this.topRight = params.topRight;
        this.bottomRight = params.bottomRight;
        this.bottomLeft = params.bottomLeft;
    }

    override toObject() {
        return {
            topLeft: this.topLeft,
            topRight: this.topRight,
            bottomRight: this.bottomRight,
            bottomLeft: this.bottomLeft
        };
    }
}
